import useIconColor from '../../hooks/useIconColor';

const Icon = () => {
  const { background } = useIconColor();

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.1078 18.5214C19.3512 22.7809 14.8855 23.9426 13.1213 23.8319C2.5912 23.3341 4.19002 9.33864 10.5301 9.39396C6.00936 12.2705 12.1841 21.7852 21.2808 18.0789C22.218 17.415 22.3834 18.2448 22.1078 18.5214Z'
        fill='url(#paint0_radial_254_542)'
      />
      <path
        d='M15.0509 11.9384C16.0433 7.40236 13.3418 4.47051 7.93895 4.47051C2.53605 4.47051 0 9.55975 0 12.1597C0 19.0191 6.89145 26.1551 15.8228 23.3892C8.43513 25.5466 4.0246 16.9723 7.77355 11.7725C10.3096 8.12149 14.5547 8.01085 15.0509 11.9384ZM20.5641 3.30884H20.6192H20.5641Z'
        fill='url(#paint1_radial_254_542)'
      />
      <path
        d='M0.0551758 11.8279C0.716755 -2.99729 21.0052 -3.82706 23.9271 9.00668C24.699 14.9257 19.1858 17.249 14.7753 15.3682C12.4598 13.93 16.2087 14.2619 14.6099 9.89177C11.9636 3.69617 0.771886 4.19403 0.0551758 11.8279Z'
        fill='url(#paint2_linear_254_542)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_254_542'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(15.5346 16.6164) scale(8.36722 7.22259)'
        >
          <stop offset='0.8' stopColor='#114488' />
          <stop offset='1' stopColor='#113377' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_254_542'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(10.3096 15.7235) scale(10.3096 10.3455)'
        >
          <stop offset='0.8' stopColor='#3388CC' />
          <stop offset='1' stopColor='#226699' />
        </radialGradient>
        <linearGradient
          id='paint2_linear_254_542'
          x1='0.0551759'
          y1='8.00314'
          x2='19.2482'
          y2='22.3592'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.1' stopColor='#55AADD' />
          <stop offset='0.6' stopColor='#55CC88' />
          <stop offset='0.8' stopColor='#77DD55' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Icon;
